const en = {
    add_company: 'Add company',
    businessarea: 'Sector',
    choose_social: 'Choose social',
    company: 'Company',
    choose_company: 'Choose company',
    manage_company: 'Manage company',
    change_company: 'Change company',
    cover_photo: 'Cover photo',
    add_cover_photo: 'Add cover photo',
    image_recommended: 'Image strongly recommended',
    company_headquarters: 'Company headquarters',
    headquarters: 'Headquarters',
    social_network: 'Social network',
    services_employer: 'Employee services',
    areas_expertise: 'Areas of expertise',
    look_for_tech_and_creative_talents: 'Search for tech and creative talents',
    search_company: 'Enter company',
    admin: 'Administrator',
    employee: 'Employee',
    human_resource: 'Human resources',
    trainer: 'Trainer',
    talents: 'Talents',
    offers: 'Offers',
    team: 'Team',
    delivery: 'Delivery',
    no_requests_for_your_company: 'There are no new requests for your company',
    add_company_message:
        'The company manager will receive a match notification and can approve or reject it',
    upload_title: 'Drag your CVs here or',
    upload_title_part_2: 'browse',
    upload_allowed_formats: 'Supported formats: PDF, DOC, DOCX',
    start_upload: 'Start upload',
    upload_search: 'Search file name',
    start_date: 'Start date',
    end_date: 'End date',
    uploading: 'Uploading...',
    upload_completed: 'Upload completed',
    to_finish: 'to finish',
    upload_of: 'Upload of',
    processed: 'Completed',
    state: 'Status',
    errors: 'Errors',
    file_added_message: 'You uploaded',
    file_added_message_1: 'CV, now start the upload',
    working_in: 'Working in',
    file_required: 'You need to upload at least one file to start the upload',
    employer_requests: 'Requests',
    employer_list: 'Employee list',
    request_to_approve: 'requests to approve',
    change_role: 'Change role',
    remove_employer: 'Dissociate user',
    assign_role: 'Assign role',
    company_profile: 'Company profile',
    company_settings: 'Company settings',
    open_hr: 'Open HR',
    vat: 'VAT',
    status: 'Status',
    date: 'Date',
    actions: 'Actions',
    who: 'Who',
    what: 'What',
    where: 'Where',
    how: 'How',
    remote_or_on_site: 'Hybrid, remote or on-site?',
    opportunity_type: 'Opportunity type',
    recruit_talent_cta: 'Do you want to contact the selected candidates for recruiting?',
    confirm: 'Confirm',
    talent_result_message:
        'You found {yourDb} talents in your database and {ourDb} talents in the WH database',
    profile_saved_by: 'Profile saved by {count} companies',
    order_by: 'Order by',
    active: 'Active',
    passive: 'Passive',
    activate_openhr: 'Activate Open HR',
    activate_service: 'Activate service',
    connect_with_providers: 'Connect with the providers you work with',
    extend_talent_search: 'Expand talent searches',
    passage: 'Step {step} of {total}',
    openhr_activation: 'Open HR activation',
    confirm_company_data: 'Confirm your company data',
    confirm_company_data_subtitle: 'Review your company data and make sure it is correct',
    company_name: 'Company name',
    registered_office: 'Registered office',
    sector: 'Sector',
    your_confirmation: 'Your confirmations',
    profilation: 'Open Wh! profiling',
    profilation_subtitle:
        'Do you consent to the processing and profiling of your personal and special data, acquired by Wh! as part of the Open HR service, together with other data, to deduce products/services of potential interest to you as well as your preferences, tastes, and behaviors?',
    do_not_accept: 'I do not accept',
    openhr_service: 'OpenHR Service',
    acknowledgment: 'Acknowledgment',
    contract_cta:
        'To sign the contract, enter your personal Wh! password and the confirmation code you received at your verified email address',
    openhr_profiling: 'Open HR profiling',
    openhr_privacy: 'Privacy consent',
    confirmation_code: 'Confirmation code',
    restore_code: 'Recover code',
    openhr_search:
        'Enter the VAT number preceded by the country code (e.g. IT12345678910)',
    db_visibility: 'Grant external visibility to my talent database',
    db_visibility_subtitle: 'Only the macro data of your database will be visible',
    all_db_visible: 'Full database visibility',
    rejected_profiles: 'Visibility of rejected profiles only',
    professionals: 'Professionals',
    connect: 'Connect',
    best_plan_for_your: 'What is the best plan for you?',
    free_plan: 'Try for free. No credit card required.',
    select_later: 'Choose later',
    subscription_plan: {
        option_popular: 'Most popular option',
        free: {
            title: 'FREE',
            month_employee: 'per month & employee',
            basic: 'Basic',
            plan_desc:
                'But I must explain to you how all this mistaken idea of denouncing point.',
            functionalities: 'Main features',
            continue_free: 'Continue with the free plan',
        },
        professional: {
            from: 'from',
            month_employee: 'per month & employee',
            professional: 'Professional',
            plan_desc:
                'But I must explain to you how all this mistaken idea of denouncing point.',
            functionalities: 'All Basic features plus:',
            calculate_cost: 'Calculate costs',
        },
        enterprise: {
            title: 'Price on request',
            enterprise: 'Enterprise',
            plan_desc:
                'But I must explain to you how all this mistaken idea of denouncing point.',
            functionalities: 'All Professional features plus:',
            contact_team: 'Contact the sales team',
        },
        calculate_prices: 'Calculate costs',
        company_dimension: 'Company size',
        billing_cycle: 'Billing cycle',
        select_plan: 'Choose plan',
        open_job_positions: 'Published job positions',
        open_hr: 'Open HR',
        price_information: 'Price information',
        enterprise_plan: 'Enterprise plan',
        recruiting: 'Recruiting',
        monthly_payment: 'Monthly payment',
        yearly: 'yearly',
        buy: 'Buy',
    },
    not_working_here_anymore: 'No longer works here',
    employee_removed: 'Employee successfully removed',
    delete_employee: 'Are you sure you want to remove this employee?',
    talent_search_detail: {
        contact_info: 'Reference account contact info',
        talent_score: 'Talent score',
        suggestions: 'Suggestions',
        inferences_map: 'Inference map',
        soft_skills: 'Soft skills',
        profile_matching: 'Profile match with your search',
        overview: 'Overview',
        video_curricula: 'Video CV',
        top_hard_skills: 'Top hard skills',
        set_interview: 'Set up a video interview',
        data_from: 'Data source',
        reliability: 'Reliability',
        personality: 'Personality',
        potential: 'Potential',
        experience: 'Experience',
        leadership: 'Leadership',
        experience_data: 'Experience data',
        sector: 'Sector',
        dimension: 'Dimension',
        companies: 'Companies',
        work_companies: 'Companies worked at',
        number_working_experience: 'Number of work experiences',
        company_change_frequency: 'Company change frequency',
        companyInfo: 'This profile is managed by {company}',
        evaluations: 'Evaluations',
        addEvaluation: 'Add evaluation',
        hard_skills: 'Hard skills',
        professional_qualifications: 'Professional qualification',
        cv: 'cv',
        save_search: {
            title: 'Name your search. You can save and resume it later.',
            search_placeholder: 'Search name',
            title_save_talent: 'Add talents to your search, select them and click save',
        },
        between_and: 'between {from} and {to}',
        every_time: 'every {year} years',
        secondary_qualification: 'Secondary qualification',
        training: 'Training',
        tipology: 'Type',
        summary: 'Summary',
    },
    request_talent_meeting: {
        title: 'Meet the candidate with a video interview',
        subtitle:
            'Enter three options for the video call. The candidate may propose other dates.',
        info: 'By clicking send, an email will be sent to the candidate.',
        insert_message: 'Enter a message.',
        send_request: 'Send and wait for confirmation',
        add_info: 'Add offer details',
        meeting_requested: 'Meeting successfully requested',
    },
    send_confirmation: {
        title: 'Choose the interview date',
        subtitle:
            'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system.',
        send_request: 'Send and wait for confirmation',
    },
    add_offert_detail: {
        title: 'Offer details',
        configure_new: 'Configure a new offer',
        duplicate: 'Duplicate an existing offer',
        choose_existing: 'Choose an existing offer',
        next: 'Next',
    },
    create_new_offert: {
        title: 'Information (1 of 2)',
        ads_title_placeholder: 'Offer title',
        opportunity_type: 'Opportunity type',
        hiring: 'hiring',
        freelance: 'freelance',
        opportunity_features: 'Opportunity features',
        less_1_year: 'less than 1 year',
        over_1_year: 'more than 1 year',
        job_place: 'Workplace location',
        remote: 'remote',
        in_office: 'on-site',
        mixed: 'mixed',
        job_address: 'Workplace info',
    },
    create_new_offert_2: {
        title: 'Information (2 of 2)',
        activate_chat: 'Do you want to activate the chat service?',
        yes: 'yes',
        no: 'no',
        send_and_wait_confirmation: 'Send and wait for confirmation',
    },
    talent_search_history: {
        title: 'Saved search history',
        search_placeholder: 'Search',
        table: {
            head: {
                name: 'Search name',
                prifle: 'Searched profile',
                data: 'Date',
                saved: 'Saved',
                conversed: 'Interviewed',
            },
        },
    },
    draft_candidate: {
        title: 'You are discarding a candidate, tell us the reasons to improve the AI algorithms.',
        subtitle: 'Until your company data is verified you cannot publish job offers.',
        add_valuation: 'Add evaluation',
    },
    in_selections: 'In selection',
    refused: 'Rejected',
    interview_panel: {
        title: 'Interviews',
        second_interview: 'Second interview',
        interviews_history: 'Interview history',
        interview: 'Interview',
        interview_status: 'Evaluation in progress',
    },
    talent_search_filters: {
        contact_info: 'Contact information',
        talent_score: 'Talent score',
        suggestions: 'Suggestions',
        inferences_map: 'Inference map',
        experience: 'Experiences',
        soft_skills: 'Soft skill',
        evaluations: 'Evaluations',
    },
    contact_info_reference: 'Reference account contact info',
    no_employees: 'There are no employees in your company',
    no_jobAnnouncements: 'You have no job offers to display.',
    no_jobAnnouncements_create: 'Start by creating a job offer.',
    other_companies_message:
        'We may have companies with a similar name. If you see your company below, you can request access.',
    add_service_employer: 'Add employee service',
    add_expertise_area: 'Add area of expertise',
    you_are_asking_to_be_paired: 'You are requesting to be matched with a company.',
    file_uploaded_tooltip:
        'Processed files are those uploaded that Wh processes for analysis by AI algorithms',
    file_completed_tooltip:
        'Wh has processed the uploaded files. The files have been indexed and the results appear in your searches according to the processing phases already completed. The process involves several phases, such as analysis by Wh AI algorithms, OpenAI analysis, Enrichment, Inference map, etc.',
    file_errors_tooltip:
        'Wh algorithms were unable to read the files you uploaded or something went wrong',
    we_are_verifying: 'You almost did it. We are verifying your company data.',
    request_sent_to_company_admin:
        'We have sent your request to the company administrator',
    we_are_verifing_data:
        'We are verifying your company, soon you will be able to publish your first job offer.',
    you_are_asking_for_a_match:
        'You are requesting to be matched with the company {companyName}. The company administrator will receive a match notification and can approve or reject it. Make sure you send the request only if you really work with this company.',
    yes_work_for_this_company: 'Yes, I work for this company',
    wait_for_the_company_administrator_to_approve:
        'Wait for the company administrator to approve your request to access company features.',
    share_offer_page: 'Offer page sharing',
    share_offer_page_message:
        'Copy and paste this link on your website to share the page with your job offers',
    share_offer_page_jobs: 'Single offer sharing',
    share_offer_page_jobs_message:
        'Copy and paste this link to share the offer with potential candidates',
    add_company_after_validation:
        'After validation, you can choose to continue with the free plan or one of our paid plans.',
    confirm_to_work_in_this_company:
        'I confirm I have the necessary permissions to operate for this company',
    click_and_confirm_to_work_in_this_company:
        'By clicking "start" you declare you work for this company.',
    your_CV: 'Your CVs',
    company_CV: 'Your company CVs',
    wh_CV: 'WH CVs',
    db_search_type: 'Search database type',
    rate: 'Rate',
    liked_profile: 'Profiles I like',
    my_offers: 'My offers',
    no_jobAnnouncements_applications: 'There are no applications for this job offer',
    process_status: {
        completed: 'Processed',
        created: 'Created',
        error: 'Error',
        loaded: 'Loaded',
        processing: 'Processing',
        uploaded: 'Uploaded',
    },
    search_saved: 'Search saved successfully',
    talent_saved: 'Talents successfully added to the search',
    process_by: 'Processed by',
    business_area_public: 'Public Administration',
    business_area_agency: 'Agency',
    business_area_company: 'Company',
    orderby_correspondence:
        'Click here to see CVs with a higher match percentage with your search',
    oderby_lastupdate: 'Click here to see the most recent CVs',
};
export default en;
